import { render, staticRenderFns } from "./AddressNew.vue?vue&type=template&id=7268b09f&scoped=true"
import script from "./AddressNew.vue?vue&type=script&lang=js"
export * from "./AddressNew.vue?vue&type=script&lang=js"
import style0 from "./AddressNew.vue?vue&type=style&index=0&id=7268b09f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268b09f",
  null
  
)

export default component.exports